import { gql } from '@apollo/client';

export const USEFUL_GUIDE = gql`
  query usefulGuide {
    usefulGuide {
      data {
        id
        attributes {
          buildings {
            data {
              id
              attributes {
                slug
                title
              }
            }
          }
          preconstructBuildings {
            data {
              id
              attributes {
                slug
                title
              }
            }
          }
          saleUnits {
            data {
              id
              attributes {
                slug
                title
              }
            }
          }
          rentUnits {
            data {
              id
              attributes {
                slug
                title
              }
            }
          }
        }
      }
    }
  }
`;
